<template>
  <div v-if="showPrecoTarget && precoTarget">
    <v-chip label :class="color">
      {{ precoTarget | currency('R$', produto.produto.cotacaoProduto.produto.casasDecimais) }}
    </v-chip>
  </div>
</template>
<script>
import { getSituacaoPrecoTarget } from './matriz-utils';

const mapColor = {
  PRECO_ACIMA: {
    color: 'amber white--text darken-1 my-1',
  },
  PRECO_ABAIXO: {
    color: 'blue white--text lighten-1 my-1',
  },
  PRECO_MUITO_ACIMA: {
    color: 'error my-1',
  },
};

export default {
  props: {
    showPrecoTarget: Boolean,
    produto: Object,
  },
  data() {
    return {
      situacaoPrecoTarget: null,
    };
  },
  computed: {
    color() {
      if (!this.situacaoPrecoTarget) {
        return '';
      }
      return mapColor[this.situacaoPrecoTarget].color;
    },
    precoTarget() {
      return this.produto.produto.cotacaoProduto.produto.precoTarget;
    },
  },
  created() {
    this.situacaoPrecoTarget = getSituacaoPrecoTarget(this.produto);
  },
};
</script>
